import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/core';
import { FolderSummary, FormSummary, ParentFolder } from '..';
export var SpaceObjects = /*#__PURE__*/function (_ValueObject) {
  _inherits(SpaceObjects, _ValueObject);

  var _super = _createSuper(SpaceObjects);

  function SpaceObjects() {
    _classCallCheck(this, SpaceObjects);

    return _super.apply(this, arguments);
  }

  _createClass(SpaceObjects, [{
    key: "parentFolders",
    get: function get() {
      return this.props.parentFolders;
    }
  }, {
    key: "forms",
    get: function get() {
      return this.props.forms;
    }
  }, {
    key: "folders",
    get: function get() {
      return this.props.folders;
    }
  }, {
    key: "nextToken",
    get: function get() {
      var _this$props$nextToken;

      return (_this$props$nextToken = this.props.nextToken) !== null && _this$props$nextToken !== void 0 ? _this$props$nextToken : null;
    }
  }, {
    key: "formNextToken",
    get: function get() {
      var _this$props$formNextT;

      return (_this$props$formNextT = this.props.formNextToken) !== null && _this$props$formNextT !== void 0 ? _this$props$formNextT : null;
    }
  }, {
    key: "folderNextToken",
    get: function get() {
      var _this$props$folderNex;

      return (_this$props$folderNex = this.props.folderNextToken) !== null && _this$props$folderNex !== void 0 ? _this$props$folderNex : null;
    }
  }, {
    key: "addNewForm",
    value: function addNewForm(form) {
      var newForms = [form].concat(_toConsumableArray(this.props.forms));
      return new SpaceObjects(_objectSpread(_objectSpread({}, this.props), {}, {
        forms: newForms
      }));
    }
  }, {
    key: "addNewFolder",
    value: function addNewFolder(folder) {
      var newFolders = [].concat(_toConsumableArray(this.props.folders), [folder]);
      return new SpaceObjects(_objectSpread(_objectSpread({}, this.props), {}, {
        folders: newFolders
      }));
    }
  }, {
    key: "addNewParentFolder",
    value: function addNewParentFolder(parentFolder) {
      var newParentFolders = [].concat(_toConsumableArray(this.props.parentFolders), [parentFolder]);
      return new SpaceObjects(_objectSpread(_objectSpread({}, this.props), {}, {
        parentFolders: newParentFolders
      }));
    }
  }, {
    key: "removeForm",
    value: function removeForm(formId) {
      var newForms = this.props.forms.filter(function (form) {
        return form.id.toString() !== formId;
      });
      return new SpaceObjects(_objectSpread(_objectSpread({}, this.props), {}, {
        forms: newForms
      }));
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.parentFolders,
        argumentName: 'Parent Folders'
      }, {
        argument: props.forms,
        argumentName: 'Forms'
      }, {
        argument: props.folders,
        argumentName: 'Folders'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      return Result.ok(new SpaceObjects(props));
    }
  }, {
    key: "fromJson",
    value: function fromJson(json) {
      try {
        var _json$data = json.data,
            parentFolders = _json$data.parentFolders,
            folders = _json$data.folders,
            forms = _json$data.forms;
        var parentFoldersObjects = parentFolders.map(function (parentFolderProps) {
          var id = parentFolderProps.id,
              title = parentFolderProps.title,
              level = parentFolderProps.level;
          return ParentFolder.create({
            id: id,
            level: level,
            title: title
          }).getValue();
        });
        var folderSummaries = folders.map(function (folderSummaryProps) {
          var id = folderSummaryProps.id,
              title = folderSummaryProps.title,
              parentId = folderSummaryProps.parentId;
          return FolderSummary.create({
            id: id,
            title: title,
            parentId: parentId
          }).getValue();
        });
        var formSummaries = forms.map(function (formSummaryProps) {
          var id = formSummaryProps.id,
              title = formSummaryProps.title,
              folderId = formSummaryProps.folderId,
              updatedAt = formSummaryProps.updatedAt,
              status = formSummaryProps.status;
          return FormSummary.create({
            id: id,
            title: title,
            folderId: folderId,
            updatedAt: updatedAt,
            status: status
          }).getValue();
        });
        var props = {
          parentFolders: parentFoldersObjects,
          folders: folderSummaries,
          forms: formSummaries
        };
        return this.create(props);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return SpaceObjects;
}(ValueObject);